module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifRegularItalic.c08ea800.otf";